import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                <motion.span
                    className={`block ${lineClassName}`}
                    initial={{ y: "115%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 0.95, delay: delay + i * 0.14, ease: EASE }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export const Eyebrow = ({ children, dark = false }) => (
    <span
        className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] ${
            dark
                ? "border-aqua/30 bg-white/5 text-aqua"
                : "border-teal/25 bg-teal-soft/60 text-teal-dark"
        }`}
    >
        <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-peach" : "bg-peach-deep"}`} />
        {children}
    </span>
);

export const SectionHeading = ({ eyebrow, title, description, dark = false, align = "center" }) => (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        <Reveal>
            <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`mt-5 font-jakarta text-3xl font-extrabold leading-[1.12] tracking-tight sm:text-4xl lg:text-[2.75rem] ${
                    dark ? "text-cream" : "text-navy"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.16}>
                <p className={`mt-5 text-base leading-relaxed md:text-lg ${dark ? "text-cream/70" : "text-ink/70"}`}>
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);
